<template lang="pug">
.field-reader(v-if="data.field_type != 'money2' && data.field_type != 'switch' && data.field_type != 'technical'")
  .field-reader__name(v-if="data.field_type=='rate'") {{data.name.split("(")[0]}}
  .field-reader__name(v-else) {{data.name}}
  .field-reader__value(v-html="parseValue(data)")
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    parseValue: function(field) {
      return this.$parseFieldDataValue(field)
    }
  }
}
</script>

<style lang="scss" scope> 
  .field-reader {
    display: flex;
    flex-direction: column;
    &__name {
      font-weight: 400;
      font-size: 0.8em;
      text-transform: uppercase;
    }
    &__value {
      font-weight: 300;
      font-size: 0.9em;
    }
  }
</style>
